import { z } from "zod";
import { TournamentSchema } from "../../tournaments/shared/schemas";

export const TournamentTimelineSchema = z.object({
  upcoming: z.array(TournamentSchema),
  past: z.array(TournamentSchema),
  live: z.array(TournamentSchema),
});
